//////-------------------------------------------------------------------------------------------------------------------------
//////----------------------------ContractComponent General POPUlate in Patient & AppointMent---------------------------------------------------------------------------------------------
//////-------------------------------------------------------------------------------------------------------------------------
import { Component, OnInit, ViewChild, EventEmitter, Output, Input, OnDestroy } from '@angular/core';
import { UntypedFormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectizeComponent, ToastService } from '../../blocks';
import { UserSessionService, FormSettingsService, StockModuleSettingsParms } from '../../shared';

//servic
import { SharedDateService } from '../../shared';
import { TranslateService } from '@ngx-translate/core';
import { TherapeuticCards, TherapeuticCardsService } from './contract.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { OperationPlaceSettingsComponent } from '../../inpatient/inTransferBodies-settings/operation-place-settings.component';
import { ModalContainerComponent } from '../../blocks/ui-component/modal-container/modal-container.component';

@Component({
    selector: 'Contract-Id',
    templateUrl: 'Contract.Component.html',
    styleUrls: ['./contract.component.css']
})
export class ContractComponent implements OnInit, OnDestroy {
    discountOwnerNameAr: string;
    discountOwnerNameEn: string;
    priPricingItemsNameAr: string;
    registerMedicalCardDetailsWhenOpeningVisit: number;
    @ViewChild('popup') content: any;
    dynamicComponent: any;
    priPricingItemsNameEn: string;
    discountValue: number;
    inTransferBodies: any = {}
    patShareValue: number;
    useOldContract: number;
    inTransferBodiesBeforeContract: number;
    contractClickedBool: boolean = false;
    therapeuticCardsForm: UntypedFormGroup;
    therapeuticCard: TherapeuticCards = <TherapeuticCards>{};
    stockSettingsParms: StockModuleSettingsParms = {};
    mediclaModuleSettings: {};
    companyTypeFlag: number;
    @Input() tabindex: number;
    @Input() editable: any;
    @Input() visitType: number;
    @Input() ShowTpaDropDown: boolean;
    @Input() defaultOldContract: number;
    @ViewChild('contractSearch') contractSearch: SelectizeComponent;
    @Input() portalReg: boolean;
    @Input() hideDataFromContract: boolean;

    integratesWithNaphisePlatform: number;
    integratesWithWaseelPlatform :any;
    contractTypeId: number
    displayAllInp: Boolean = false;
    showsFlag: any = <any>{}
    @Input() set contractType(value: number) {
        if (this.contractSearch) {
            this.contractSearch.clear();
            this.contractSearch.clearItems();
        }
        this.contractTypeId = value
        this.companyTypeFlag = null
    }
    modifyCardPrivilege: number = 0
    @Output() private contractValueInfoEmitted: EventEmitter<any> = new EventEmitter();
    @Output() private inTransferBodiesValueInfoEmitted: EventEmitter<any> = new EventEmitter();
    @Input() NphiesEligablePatientContractData: any;

    private ngUnsubscribe: Subject<void> = new Subject<void>();
    private unsubscribe = new Subject();
    curruntDate: any;
    //--------------------------------------------------------------#ibrahim-gouhar---------------------------------------------------------------------------
    constructor(
        public translate: TranslateService,
        private fb: UntypedFormBuilder,
        private _userSessionService: UserSessionService,
        private _toastService: ToastService,
        private _sharedDateService: SharedDateService,
        private _formSettingsService: FormSettingsService,
        private _contractService: TherapeuticCardsService) { }
    ///---------------------- ..........#gouhar......
    ngOnInit() {

        this.getModuleSettings();
        this.therapeuticCardsForm = this.fb.group(this.initContarctModel());
        if (this.editable == undefined) {
            this.editable = true;
        }

        if (this.NphiesEligablePatientContractData) {
            this.patchNphiesEligablePatientContractData(this.NphiesEligablePatientContractData)
        }
        this.curruntDate = new Date();
        this._userSessionService.subscribeToKey$('SecLoginPrivileges').pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                if (keys.value) {
                    if (keys.value[0]['ModifyCardPrivilege'] == 1) {
                        this.modifyCardPrivilege = 1;
                    } else {
                        // this.therapeuticCardsForm.controls['cardNo'].disable();
                        this.therapeuticCardsForm.controls['policyNumber'].disable();
                        this.therapeuticCardsForm.controls['startDate'].disable();
                        this.therapeuticCardsForm.controls['endDate'].disable();
                        this.therapeuticCardsForm.controls['eligibilityNo'].disable();

                    }
                }
            })
        this.integratesWithNaphisePlatform = this._userSessionService.integratesWithNaphisePlatform;
        this.integratesWithWaseelPlatform = this._userSessionService.integratesWithWaseelPlatform;

    }
    initContarctModel() {
        // initialize  model
        const model = {
            code: -1,
            cardNo: [null, Validators.required],
            patientCode: 0,
            contractId: null,
            tpaCode: null,
            contractNotRest: null,
            policyNumber: null,
            policyholder: null,
            eligibilityNo: null,
            startDate: null,
            patSharingPercentFromCardFlag: null,
            endDate: [null, Validators.required],
            inTransferBodiesSerial: null,
            crf: null,
            deb: null,
            // nphiesEligibilityTransferReference: null, Commented by basma 
            consultation: null,
            consultationPercentOrValue: null,
            servicesPercent: null,
            glasessFlag: null,
            pregnancyFollowUpFlag: null,
            dentalConsultationFlag: null,
            dentalServicesFlag: null

        };

        return model;
    }
    displayAll() {
        this.displayAllInp = !this.displayAllInp;
    }
    contractId: number;
    patSharingPercentFromCardFlag: number
    compFirstLevelCode: number
    contractClicked(item: any) {
        this.contractId = item ? item.code : 0
        if (item != undefined) {
            this.companyTypeFlag = item.companyTypeFlag;
            this.patSharingPercentFromCardFlag = item.patSharingPercentFromCardFlag;
            console.log(' this.patSharingPercentFromCardFlag ', this.patSharingPercentFromCardFlag)
            this.compFirstLevelCode = item.compFirstLevelCode;
            if (!item.AutoEmited) {
                this.therapeuticCard.endDate = null;
                this.therapeuticCard.startDate = null;
                // this.therapeuticCard.policyNumber = null;   ----ENG.ASMAA
                this.therapeuticCard['policyNumber'] = item.policyNumber  // ----ADDED  BY ENG.ASMAA  ---FOR POLICY NUMBER  BINDING IN NAPHIES
                this.therapeuticCard['policyholder'] = item.policyholder  // ----ADDED  BY ENG.ASMAA  ---FOR POLICY NUMBER  BINDING IN NAPHIES
                this.therapeuticCard.cardNo = null;
                this.therapeuticCard.crf = null;
                this.therapeuticCard.deb = null;
                this.therapeuticCard['compNameAr'] = item.nameAr;
                this.therapeuticCard['compNameEn'] = item.nameEn;
                this.therapeuticCard['tpaNphiesID'] = item.tpaNphiesID
                this.therapeuticCard['companyNameAr'] = item.companyNameAr
                this.therapeuticCard['companyNameEn'] = item.companyNameEn
                this.therapeuticCard['nphiesPayerlicense'] = item.nphiesPayerlicense
                this.therapeuticCard['compFirstLevelCode'] = item.compFirstLevelCode

                this.therapeuticCard['consultationPercentOrValue'] = item.consultationPercentOrValue
                this.therapeuticCard['consultation'] = item.consultation
                this.therapeuticCard['servicesPercent'] = item.servicesPercent
                this.therapeuticCard['glasessFlag'] = item.glasessFlag
                this.therapeuticCard['pregnancyFollowUpFlag'] = item.pregnancyFollowUpFlag
                this.therapeuticCard['dentalConsultationFlag'] = item.dentalConsultationFlag
                this.therapeuticCard['dentalServicesFlag'] = item.dentalServicesFlag

                this.therapeuticCardsForm.get('startDate').setValue(null);
                this.therapeuticCardsForm.get('endDate').setValue(null);
                this.therapeuticCardsForm.get('cardNo').setValue(item.cardNo);
                this.therapeuticCard.cardNo = item.cardNo;
            }
            this.showsFlag.crfFlag = item.crf;
            this.showsFlag.debFlag = item.deb;
            if (this.showsFlag.crfFlag == 1) {
                this.therapeuticCardsForm.get('crf').setValidators(Validators.required);

            }
            else {
                this.therapeuticCardsForm.get('crf').setValue(null);
                this.therapeuticCardsForm.get('crf').clearValidators();
            }
            this.therapeuticCardsForm.get('crf').updateValueAndValidity();
            if (this.showsFlag.debFlag == 1) {
                this.therapeuticCardsForm.get('deb').setValidators(Validators.required);
            }
            else {
                this.therapeuticCardsForm.get('deb').clearValidators();
                this.therapeuticCardsForm.get('deb').setValue(null);
            }
            this.therapeuticCardsForm.get('deb').updateValueAndValidity();

            if (this.companyTypeFlag == 1) {
                this.therapeuticCard.endDate = null;
                this.therapeuticCard.startDate = null;
                this.therapeuticCard.policyNumber = null;
                this.therapeuticCard.cardNo = null;
                this._formSettingsService.setRequired(this.therapeuticCardsForm, null, false, 'cardNo,endDate');//#ibrahim end date required
            }
            else {
                //--------- check for CardNumEnterNecessity Flag  for mandatory Coloums --__Asmaa__------
                if (item.cardNumEnterNecessity == 1) {
                    this._formSettingsService.setRequired(this.therapeuticCardsForm, this.initContarctModel(), true, 'cardNo,endDate');
                }
                this.setFormGroupPlicy(item);
            }
            this.contractClickedBool = true;
            this.priPricingItemsNameAr = item.priPricingItemsNameAr;
            this.priPricingItemsNameEn = item.priPricingItemsNameEn;
            this.discountOwnerNameAr = item.discountOwnerNameAr;
            this.discountOwnerNameEn = item.discountOwnerNameEn;
            this.discountValue = item.discountValue;
            this.patShareValue = item.patShareValue;

            this.therapeuticCard.patSharingPercentFromCardFlag = item.patSharingPercentFromCardFlag;
        }
        else {
            this.contractClickedBool = false;
        }

        //-------------------validation on card expiary and validty
        if (item != undefined && (item.statusFlag == 0 || item.expireFlag == 1)) {
            this.contractSearch.clear();
            this._userSessionService.setSessionKey('contract', {});

            this.therapeuticCard.contractId = null;
            this.updateSessionContarct();
            if (!this.therapeuticCardsForm.value.contractId && this.therapeuticCardsForm.value.contractNotRest)
                this.editable = true
            return false;
        }

        if (item != null) {
            this.contractValueInfoEmitted.emit(item.code);
            this._userSessionService.setSessionKey('contract', item);
            this.therapeuticCard.contractId = item.code;
            this.updateSessionContarct();
        } else {
            this.contractValueInfoEmitted.emit(null);
            this._userSessionService.setSessionKey('contract', null);
        }

    }



    patchNphiesEligablePatientContractData(contractData) {
        this.therapeuticCardsForm.patchValue({
            code: contractData.companyCode,
           // patientCode: contractData.patientCode,
            cardNo: contractData.memberId,
            contractId: contractData.companyCode,
            startDate: this._sharedDateService.convertFromDateToNgBsObject(contractData.contractStartDate),
            endDate: this._sharedDateService.convertFromDateToNgBsObject(contractData.contractEndDate),
            policyNumber: contractData.policyNumber,
    })
    console.log('patchNphiesEligablePatientContractData_', contractData);
    console.log('patchNphiesEligablePatientContract FORM_',  this.therapeuticCardsForm);
    this.updateSessionContarct();
}
    //////-------------------------------------------------------------------------------------------------------------------------
    resetContract() {
        this.therapeuticCardsForm.reset();
        this.inTransferBodies = {};
    }
    //////-------------------------------------------------------------------------------------------------------------------------
    //////main #gouhar...........////
    getTherapeuticCardsForm(): TherapeuticCards {
        let temp = <TherapeuticCards>(this.therapeuticCardsForm.value);
        temp.startDate = this._sharedDateService.convertFromNgBsToDate(this.therapeuticCardsForm.get('startDate').value);
        temp.endDate = this._sharedDateService.convertFromNgBsToDate(this.therapeuticCardsForm.get('endDate').value);
        temp['compNameAr'] = this.therapeuticCard['compNameAr']
        temp['compNameEn'] = this.therapeuticCard['compNameEn']
        temp['tpaNphiesID'] = this.therapeuticCard['tpaNphiesID']
        temp['companyNameEn'] = this.therapeuticCard['companyNameEn']
        temp['companyNameAr'] = this.therapeuticCard['companyNameAr']
        temp['companyTypeFlag'] = this.companyTypeFlag
        temp['patSharingPercentFromCardFlag'] = this.therapeuticCard['patSharingPercentFromCardFlag']
        temp['nphiesPayerlicense'] = this.therapeuticCard['nphiesPayerlicense']
        temp['policyNumber'] = this.therapeuticCard['policyNumber']
        temp['policyholder'] = this.therapeuticCard['policyholder']
        temp['compFirstLevelCode'] = this.therapeuticCard['compFirstLevelCode']
        temp['compSecondLevelCode'] = this.therapeuticCard['compSecondLevelCode']

        temp['consultationPercentOrValue'] = this.therapeuticCardsForm.get('consultationPercentOrValue').value
        temp['consultation'] = this.therapeuticCardsForm.get('consultation').value
        temp['servicesPercent'] = this.therapeuticCardsForm.get('servicesPercent').value
        temp['glasessFlag'] = this.therapeuticCardsForm.get('glasessFlag').value == true ? 1 : 0
        temp['pregnancyFollowUpFlag'] = this.therapeuticCardsForm.get('pregnancyFollowUpFlag').value == true ? 1 : 0
        temp['dentalConsultationFlag'] = this.therapeuticCardsForm.get('dentalConsultationFlag').value == true ? 1 : 0
        temp['dentalServicesFlag'] = this.therapeuticCardsForm.get('dentalServicesFlag').value == true ? 1 : 0

        return temp;
    }
    //////-------------------------------------------------------------------------------------------------------------------------
    //////-------------------------------------------------------------------------------------------------------------------------
    setFormGroupContract(temp: any) {
        if (temp.contractId) {
            this.therapeuticCardsForm.patchValue({
                contractId: temp.contractId
            }, { emitEvent: false })
        }
    }
    //////-------------------------------------------------------------------------------------------------------------------------
    setFormGroupPlicy(temp: any) {
        if (temp.policyNumber) {

            this.therapeuticCardsForm.patchValue({
                policyNumber: temp.policyNumber

            }

                , { emitEvent: false })

            this.therapeuticCard.policyNumber = temp.policyNumber;

        }
        else {
            this.therapeuticCardsForm.patchValue({
                policyNumber: null

            })
            this.therapeuticCard.policyNumber = null;

        }

        if (temp.startDate) {
            this.therapeuticCardsForm.get('startDate').setValue(this._sharedDateService.convertFromDateToNgBsObject(temp.startDate));
            this.therapeuticCard.startDate = temp.startDate;
        }
        else {
            this.therapeuticCardsForm.patchValue({
                startDate: null
            })
            this.therapeuticCard.startDate = null;


        }

        if (temp.endDate) {
            this.therapeuticCardsForm.get('endDate').setValue(this._sharedDateService.convertFromDateToNgBsObject(temp.endDate));
            this.therapeuticCard.endDate = temp.endDate;

        }
        else {
            this.therapeuticCardsForm.patchValue({
                endDate: null

            })
            this.therapeuticCard.endDate = null;

        }

    }
    //////-------------------------------------------------------------------------------------------------------------------------

    ///PopUlate Cotract #Gouhar
    setFormGroup(temp: any) {
        this.therapeuticCardsForm.patchValue({
            code: temp.code,
            patientCode: temp.patientCode,
            cardNo: temp.cardNo,
            crf: temp.crf,
            deb: temp.deb,
            contractId: temp.contractId,
            inTransferBodiesSerial: temp.inTransferBodiesSerial,
            contractNotRest: temp.contractNotRest,
            startDate: this._sharedDateService.convertFromDateToNgBsObject(temp.startDate),
            endDate: this._sharedDateService.convertFromDateToNgBsObject(temp.endDate),
            policyNumber: temp.policyNumber,

            consultationPercentOrValue: temp.consultationPercentOrValue,
            consultation: temp.consultation,
            servicesPercent: temp.servicesPercent,
            glasessFlag: temp.glasessFlag,
            pregnancyFollowUpFlag: temp.pregnancyFollowUpFlag,
            dentalConsultationFlag: temp.dentalConsultationFlag,
            dentalServicesFlag: temp.dentalServicesFlag,

            patSharingPercentFromCardFlag: temp.patSharingPercentFromCardFlag
        }, { emitEvent: false })

        this.therapeuticCard = temp;
        if (temp.CompanyType) {
            this.companyTypeFlag = temp.CompanyType;
        }
        this.updateSessionContarct();
    }
    //////-------------------------------------------------------------------------------------------------------------------------

    updateFormControl(therapeuticCard: UntypedFormControl, value: string) {
        this.therapeuticCardsForm.patchValue({ name: value }, { emitEvent: false })
    }
    //////-------------------------------------------------------------------------------------------------------------------------

    getTherapeuticCardsFormGroup() {
        return this.therapeuticCardsForm;
    }
    //////-------------------------------------------------------------------------------------------------------------------------
    //used by passing an model object to get therapeuticCard properties from it  and return  new object of  TherapeuticCards
    gettherapeuticCardObjFromModel(MVObj: any) {
        let therapeuticCard = <TherapeuticCards>{};
        if (MVObj) {
            therapeuticCard.code = MVObj.code;
            therapeuticCard.cardNo = MVObj.cardNo;
            therapeuticCard.crf = MVObj.crf;
            therapeuticCard.deb = MVObj.deb;
            therapeuticCard.contractId = MVObj.contractId;
            therapeuticCard.endDate = this._sharedDateService.convertFromDateToNgBsObject(MVObj.endDate);
            therapeuticCard.policyNumber = MVObj.policyNumber;
            therapeuticCard.patSharingPercentFromCardFlag = MVObj.patSharingPercentFromCardFlag;
            therapeuticCard.startDate = this._sharedDateService.convertFromDateToNgBsObject(MVObj.startDate);

            therapeuticCard.consultationPercentOrValue = MVObj.consultationPercentOrValue,
                therapeuticCard.consultation = MVObj.consultation,
                therapeuticCard.servicesPercent = MVObj.servicesPercent,
                therapeuticCard.glasessFlag = MVObj.glasessFlag,
                therapeuticCard.pregnancyFollowUpFlag = MVObj.pregnancyFollowUpFlag,
                therapeuticCard.dentalConsultationFlag = MVObj.dentalConsultationFlag,
                therapeuticCard.dentalServicesFlag = MVObj.dentalServicesFlag
        }
        return therapeuticCard;

    }

    //////-------------------------------------------------------------------------------------------------------------------------
    setContract() {
        this.therapeuticCard = this.getTherapeuticCardsForm();
        if (this.therapeuticCard.endDate == null && this.companyTypeFlag == 2) {
            this._toastService.activateMsg('UI34');
            return false;
        }
        this.updateSessionContarct();
    }
    updateSessionContarct() {
        this._userSessionService.setSessionKey('contractObjectForm', this.therapeuticCard);
    }


    getNewInstance(patCode: number, contractId: number): TherapeuticCards {
        let ss = <TherapeuticCards>{
            code: -1,
            cardNo: null,
            patientCode: patCode,
            contractId: contractId,
            policyNumber: null,
            startDate: null,
            endDate: null,
        }
        // this.therapeuticCard = ss;
        //this.updateSessionContarct();
        this.setFormGroup(ss);
        if (!ss.contractId)
            this.editable = true;

        return ss;
    }
    crfFlagError: any
    debFlagError: any
    onValuesChange() {
        this.crfFlagError = this.therapeuticCardsForm.get('crf').value
        this.debFlagError = this.therapeuticCardsForm.get('deb').value
        this.therapeuticCard = this.getTherapeuticCardsForm();
        //if( this.therapeuticCard.endDate > this.curruntDate)
        this.updateSessionContarct();
    }
    //////-------------------------------------------------------------------------------------------------------------------------
    validate(): boolean {

        if (!this.therapeuticCardsForm.valid) {
            this._toastService.activateMsg('UI35');
            return false;
        }
        return true;
    }
    onpopupClose(parms: any) { }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    moduleId: number;
    getModuleSettings() {
        this._userSessionService.subscribeToKey$('link')
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(link => {
                if (link.name = 'link') {
                    this.stockSettingsParms.moduleId = 39
                    this._userSessionService.subscribeToKey$('modulesSettings')
                        .pipe(takeUntil(this.ngUnsubscribe))
                        .subscribe((keys: any) => {
                            if (keys.value) {
                                this.mediclaModuleSettings = keys.value[`m_${this.stockSettingsParms.moduleId}`];
                                this.useOldContract = this.mediclaModuleSettings['useOldContract'];
                                this.inTransferBodiesBeforeContract = +this.mediclaModuleSettings['inTransferBodiesBeforeContract'];
                                this.registerMedicalCardDetailsWhenOpeningVisit = +this.mediclaModuleSettings['registerMedicalCardDetailsWhenOpeningVisit'];
                                console.log('v', this.registerMedicalCardDetailsWhenOpeningVisit)
                            }
                        });
                    if (!this.mediclaModuleSettings || !this.useOldContract) {
                        this._contractService.getStockModuleSettings(this.stockSettingsParms)
                            .pipe(takeUntil(this.ngUnsubscribe))
                            .subscribe(c => {
                                if (c.data && c.data.length > 0) {
                                    this.mediclaModuleSettings = c.data[0];
                                    if (this.mediclaModuleSettings) {
                                        this.useOldContract = this.mediclaModuleSettings['useOldContract'];
                                        this.inTransferBodiesBeforeContract = +this.mediclaModuleSettings['inTransferBodiesBeforeContract'];
                                        this.registerMedicalCardDetailsWhenOpeningVisit = +this.mediclaModuleSettings['registerMedicalCardDetailsWhenOpeningVisit'];

                                        console.log('x', this.registerMedicalCardDetailsWhenOpeningVisit)
                                        console.log('inTransferBodiesBeforeContractx = ', this.inTransferBodiesBeforeContract)

                                    }
                                }
                            });
                    }
                }
            });
    }
    inTransferClicked(item: any) {
        ;
        //.----------------------
        if (item != undefined) {
            this.inTransferBodies = item
            this.inTransferBodiesValueInfoEmitted.emit(item);

        }
    }

    onConsultationPercentOrValueClicked(ev: any) {
        if (ev != undefined) {
            this.therapeuticCard.consultationPercentOrValue = ev.code
            this.updateSessionContarct();
        }
    }
    openinTransfer() {
        this.dynamicComponent = OperationPlaceSettingsComponent;
        this.content.openModal("OrderAddComponent", "Reservations", {});

    }
    // companyChecklistPopup() {
    //     this.dynamicComponent = OperationPlaceSettingsComponent;
    //     this.content.openModal("OrderAddComponent", "Reservations", {});
    // }
    @ViewChild('content') popup: ModalContainerComponent;
    companyChecklistPopup() {
        let obj = { companyCode: this.compFirstLevelCode }
        this.getCompanyCheckList(obj);
        this.popup.openModal('LabSearchComponent', 'parms', {}, 'lg');
    }
    onModalClose(ev: any) { }
    arrCompanyCheckList: any = [];
    getCompanyCheckList(obj: any) {
        this._contractService.getPriCompanyCheckList(obj)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(res => {
                this.arrCompanyCheckList = res.data;
            });

    }
}

